exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common_form_search[data-v-14bb75c6]{padding:15px 30px 0;background-color:#ffffff;border-bottom:1px solid #eeeeee}.child_page[data-v-14bb75c6]{padding:30px 30px 15px 30px}\n", ""]);

// exports
